import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactComponent as OnboardingMedication } from 'assets/OnboardingMedication.svg';
import Theme from 'theme';

function MedicationHistoryStep() {
  return (
    <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center' mb={4.5}>
      <Box sx={{ width: '100%', mb: 4.5 }}>
        <OnboardingMedication width='90%' height='90%' />
      </Box>
      <Typography variant='h6' fontWeight={500} sx={{ mb: 2 }} color={Theme.custom.colors.lightTextPrimary}>
        Get medication history
      </Typography>
      <Typography variant='body1' sx={{ color: Theme.custom.colors.lightTextPrimary, textAlign: 'center' }}>
        Patients activate their accounts on the
        {' '}
        <b>
          free patient app
        </b>
        , and consent to
        <br />
        providing access to their Health records.
      </Typography>
    </Box>
  );
}

export default MedicationHistoryStep;
